@if (!successPaymentMessage) {
  <ng-container [class.block]="message?.stripError">
    <p>
      Tus pagos son procesados con :
      <fa-icon [icon]="iconStripe" size="2x"></fa-icon>
    </p>

    <div [formGroup]="stripeCardForm" ngxStripeCardGroup [elementsOptions]="elementsOptions" [stripe]="stripe">
      <div class="row container_card">
        <div class="col-12">
          <ngx-stripe-card-number [options]="cardOptions" containerClass="input-card mb-3 "></ngx-stripe-card-number>
        </div>
        <div class="col-6">
          <ngx-stripe-card-expiry [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-expiry>
        </div>
        <div class="col-6">
          <ngx-stripe-card-cvc [options]="cardOptions" containerClass="mb-3 input-card"></ngx-stripe-card-cvc>
        </div>
      </div>

      <button type="submit" (click)="createToken()" class="btn btn__default btn__block mt-3 mb-3" [class.d-block]="!loadingToken" [class.d-none]="loadingToken">Comprar</button>
      <div class="text-center" [class.d-block]="loadingToken" [class.d-none]="!loadingToken">
        <fa-icon [icon]="iconSpinner" size="4x" animation="spin" [style]="{ color: 'white' }"></fa-icon>
      </div>
    </div>

    <p i18n>Al dar click en Pagar damos por hecho de que aceptas nuestros Términos y Condiciones y Política de Devolución y Reembolso</p>
  </ng-container>
}
